import classNames from "classnames";
import { createUseStyles } from "react-jss";

interface Props {
  className?: string;
  label?: string;
  onClick: () => void;
  children?: any;
  loading?: boolean;
}

const useStyles = createUseStyles({
  root: {
    textDecoration: "none",
    borderRadius: "5px",
    padding: "13px 22px",
    color: "#002F6C",
    background: "#F6BB60",
    fontWeight: "bold",
    fontSize: "16px",
    "&:hover": {
      cursor: "pointer",
    },
    width: "fit-content",
  },
});

const Button = ({ className, label, onClick, children, loading }: Props) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)} onClick={onClick}>
      {!loading ? label : children}
    </div>
  );
};

export default Button;
